function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M128.931 87.0427C126.384 84.4852 123.356 82.4571 120.02 81.0757C116.685 79.6943 113.108 78.9869 109.498 78.9944C105.744 78.952 102.024 79.6976 98.5773 81.1831C95.1306 82.6685 92.0344 84.8606 89.4891 87.6176C87.0439 90.2618 85.7344 93.7592 85.842 97.3581C85.9496 100.957 87.4657 104.37 90.0644 106.864C92.6588 109.362 96.1318 110.741 99.7345 110.704C103.337 110.666 106.781 109.215 109.323 106.664C110.6 105.386 112.117 104.373 113.786 103.682C115.456 102.991 117.245 102.635 119.052 102.635C120.859 102.635 122.648 102.991 124.318 103.682C125.987 104.373 127.504 105.386 128.781 106.664C131.364 109.246 132.815 112.748 132.815 116.399C132.815 120.05 131.364 123.552 128.781 126.135C126.255 128.658 123.251 130.651 119.944 131.999C116.637 133.347 114.546 134.466 109.523 133.983C104.5 133.5 103.27 132.734 99.1618 130.529C95.0536 128.324 90.0644 125.91 90.0644 125.91M90.0644 125.91L104.921 123.785M90.0644 125.91L92.1903 140.757M114.125 89.1672L128.956 87.0427L126.855 72.1958M77.0087 173.975V156.478C77.0142 148.731 74.4356 141.202 69.6805 135.083C63.0727 126.556 59.4915 116.074 59.5011 105.289C59.5011 92.3623 64.6395 79.9652 73.7858 70.8247C82.9322 61.6842 95.3373 56.5491 108.272 56.5491C120.184 56.5477 131.683 60.9049 140.6 68.7979C149.516 76.6908 155.232 87.5733 156.668 99.3901C157.005 102.131 157.712 104.813 158.769 107.363L169.124 132.208C169.443 132.973 169.566 133.806 169.483 134.63C169.4 135.455 169.113 136.246 168.649 136.932C168.182 137.613 167.554 138.168 166.821 138.548C166.088 138.927 165.272 139.119 164.447 139.107H156.943V159.103C156.943 160.429 156.416 161.7 155.478 162.638C154.54 163.575 153.268 164.102 151.941 164.102H136.935C136.275 164.101 135.621 164.231 135.011 164.484C134.402 164.737 133.849 165.109 133.383 165.576C132.92 166.043 132.553 166.597 132.304 167.206C132.055 167.816 131.929 168.468 131.933 169.126V174.125L77.0087 173.975Z",
  stroke: "url(#paint0_linear)",
  strokeWidth: 4,
  strokeMiterlimit: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2001 44.5859C33.6877 32.3121 45.5906 22.1134 59.1739 14.6198C72.7572 7.12624 87.7326 2.49678 103.175 1.01734C118.618 -0.462101 134.2 1.23989 148.959 6.01821C163.718 10.7965 177.34 18.5497 188.986 28.799C200.631 39.0483 210.051 51.5761 216.666 65.6087C223.28 79.6413 226.947 94.8808 227.441 110.386C227.934 125.892 225.244 141.334 219.537 155.759C213.829 170.184 205.225 183.286 194.255 194.255",
  stroke: "url(#paint1_linear)",
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M145.061 223.165C125.177 228.823 104.125 228.942 84.1778 223.51C64.2307 218.078 46.1461 207.3 31.8762 192.342C17.6063 177.383 7.69309 158.811 3.2067 138.63C-1.27969 118.449 -0.168874 97.4257 6.41925 77.8299",
  stroke: "url(#paint2_linear)",
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 45.6092,
  y1: 88.5992,
  x2: 185.366,
  y2: 115.531,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 256.79,
  y1: 165.848,
  x2: -31.3979,
  y2: 106.493,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: -28.7899,
  y1: 62.1504,
  x2: 259.398,
  y2: 121.505,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 115,
  height: 120,
  fill: "white",
  transform: "translate(57 54)"
})));

function SvgOverthink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverthink);
export default __webpack_public_path__ + "static/media/overthink.e5ff1006.svg";
export { ForwardRef as ReactComponent };